var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState } from 'react';
import { Icon, Typography } from '@material-ui/core';
import { TreeItem, TreeView } from '@material-ui/lab';
import { Panel, PanelContent, PanelHeader } from '@sierralabs/core-ui';
import { useSiteContext } from '../SiteContext';
const SiteComponentsPanel = () => {
    const { configureComponent, selectedRootComponent, setSelectedComponent, setHoverComponent, setEditPath, isHover } = useSiteContext();
    // expand all
    const defaultExpanded = useMemo(() => {
        if (!selectedRootComponent)
            return [];
        const getIds = (component, ids) => {
            if (!ids)
                ids = [];
            ids.push(component.id);
            if (component.children) {
                for (const child of component.children) {
                    getIds(child, ids);
                }
            }
            return ids;
        };
        return getIds(selectedRootComponent);
    }, [selectedRootComponent]);
    const [expanded, setExpanded] = useState(defaultExpanded);
    useEffect(() => setExpanded(defaultExpanded), [defaultExpanded]);
    return (React.createElement(Panel, { className: 'site-components' },
        React.createElement(PanelHeader, null,
            React.createElement(Typography, { variant: 'overline' }, "Components")),
        React.createElement(PanelContent, null, selectedRootComponent && (React.createElement(TreeView, { defaultCollapseIcon: React.createElement(Icon, null, "arrow_drop_down"), defaultExpandIcon: React.createElement(Icon, null, "arrow_right"), defaultExpanded: defaultExpanded, defaultSelected: (configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.id) || '', selected: (configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.id) || '', expanded: expanded },
            React.createElement(SiteComponentItem, { component: selectedRootComponent, onIconClick: component => {
                    if (expanded.some(id => component.id === id)) {
                        setExpanded(expanded.filter(id => id !== component.id));
                    }
                    else {
                        setExpanded([...expanded, component.id]);
                    }
                }, onLabelClick: component => {
                    var _a;
                    const getParentRoute = (component) => {
                        if (component.type === 'route')
                            return component;
                        if (component.parent)
                            return getParentRoute(component.parent);
                    };
                    const routeComponent = getParentRoute(component);
                    if ((_a = routeComponent === null || routeComponent === void 0 ? void 0 : routeComponent.props) === null || _a === void 0 ? void 0 : _a.path) {
                        setEditPath(routeComponent.props.path);
                    }
                    // console.log('setSelectedComponent', component);
                    setSelectedComponent(component);
                }, onMouseOver: component => {
                    if (!isHover(component)) {
                        setHoverComponent(component);
                    }
                }, onMouseOut: component => {
                    if (isHover(component)) {
                        setHoverComponent(undefined);
                    }
                } }))))));
};
export default SiteComponentsPanel;
const SiteComponentItem = (_a) => {
    var _b;
    var { component, onIconClick, onLabelClick, onMouseOver, onMouseOut } = _a, props = __rest(_a, ["component", "onIconClick", "onLabelClick", "onMouseOver", "onMouseOut"]);
    return (React.createElement(TreeItem, Object.assign({ nodeId: component.id, label: React.createElement("div", { className: 'item-label', onMouseOver: () => onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(component), onMouseOut: () => onMouseOut === null || onMouseOut === void 0 ? void 0 : onMouseOut(component) }, component.name), onIconClick: () => onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick(component), onLabelClick: event => {
            event.preventDefault();
            onLabelClick === null || onLabelClick === void 0 ? void 0 : onLabelClick(component);
        } }, props), (_b = component.children) === null || _b === void 0 ? void 0 : _b.map(component => (React.createElement(SiteComponentItem, Object.assign({ key: component.id, component: component, onIconClick: onIconClick, onLabelClick: onLabelClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut }, props))))));
};
//# sourceMappingURL=SiteComponentsPanel.js.map